
export const BIZ_DATA_PREFIX =  "/base-biz-data-server";
export const IAM_PREFIX = "/iam-auth-web/auth";
export const WS_TRUCK ="/harbour-server";
